import { connect } from 'react-redux';
import { deleteTier } from '../../redux/creator/actions';
const mapDispatchToProps = (dispatch, { deviation })=>({
        deleteTier: (afterActionUrl)=>dispatch(deleteTier(deviation, afterActionUrl))
    });
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=DeleteTier.container.js.map